import GetImage from '../../components/getimage/Getimage';
import { StatusComponent } from './StatusComponent';
import { getMeetingDay } from './utility/getMeetingDay';
import getMeetingTime from './utility/getMeetingTime';
import meetingmom from "../../assets/document.png"
import attendees from "../../assets/teammeeting.png"
import './meetinglist.css'
import { useEffect } from 'react';
const Meetinglist = ({list,GetMeetingDetails,meetingid}) => {
  const getDateOnly=(date)=>{
    console.log(date,"dateeeeeee")
    return date?.split(" ")[0]
  }
let lastDate = "";
  return (
    <div style={{position:"relative"}}>
        {list && (
          <div className='meetingscroll' >
            {
              list?.length > 0 ? <div>
                {
                  list?.map((item,index)=>{
                     const currentDate = getDateOnly(item?.scheduledtime?.date);
                     const showHeader = (item.stage == 0 && currentDate !== lastDate)
                       if (item.stage == 0) {
                  lastDate = currentDate;
                }
return(
  <div onClick={()=>GetMeetingDetails(item?.meetingid)} key={item?.meetingid} className={`meetingtilenew meeting-item ${meetingid == item?.meetingid ? 'activemeeting' : ''}`}  
          style={{ animationDelay: `${index * 0.1}s` }}>

             {showHeader && (
        <div className="dateHeader">
         <div style={{display:"flex" , justifyContent:"space-between" , alignItems:"center", marginBottom:"10px"}}>
      <p style={{marginBottom:"0px"}} className='scheduledmeeting'><StatusComponent data={item}/></p>
      <p style={{marginBottom:"0px"}} className='todaymeeting'>{getMeetingDay(item?.scheduledtime?.date)}</p>
      </div>
        </div>
      )}
      {item.stage != 0 && (
        <div className="dateHeader">
         <div style={{display:"flex" , justifyContent:"space-between" , alignItems:"center", marginBottom:"10px"}}>
      <p style={{marginBottom:"0px"}} className='scheduledmeeting'><StatusComponent data={item}/></p>
      <p style={{marginBottom:"0px"}} className='todaymeeting'>{getMeetingDay(item?.scheduledtime?.date)}</p>
      </div>
        </div>
      )}
    
      <div className={`meetingtile ${meetingid == item?.meetingid ? 'activemeeting' : ''}`} >
         <div className='leftsec'>
         <div className='imagesection'>
        <div>
          <GetImage key={item?.hostempid} imgID={item?.hostempid} width='45px' height='45px'/>
          </div>
          <div>
            <p style={{marginBottom:"0px"}} className='meetingddescription'>{item?.name}</p>
            <div className='timemeeting'>
            <span>{getMeetingTime(item?.scheduledtime?.date)}</span> - <span>{getMeetingTime(item?.endtime?.date)}</span>
              </div>
          </div>
      </div>

      <div className='attendeesmom'>
        {
          item.hasmom != 0 ? <img src={meetingmom} className='img-fluid meetinggroupimg'/> : ""
        }
        {
          item?.attendees ? <img src={attendees} className='img-fluid meetinggroupimg'/> : ""
        }
        <p style={{marginBottom:"0px",fontWeight:"600"}} className='todaymeeting'>
{
          item?.attendees
        }
        </p>
        
        </div>
        </div>
        </div>
     
    </div>
)
                  })
                }
                </div>  : ""
            }
          </div>
        )}

    </div>
  );
};
export default Meetinglist;